/* eslint-disable max-len */
import { CSSProperties, useEffect, useState } from "react";

import { Grid, Modal, styled, SwipeableDrawer, useMediaQuery, useTheme } from "@mui/material";
// import DarkJungle from "../../assets/dark-forest.jpg";
// import PaddyCrops from "../../assets/crops.jpg";
import { DocumentScannerOutlined, EnergySavingsLeafOutlined, Public } from "@mui/icons-material";
import { Link } from "react-router-dom";
import {
  ActionBtn,
  Attention,
  BlogStoryBlock,
  CustomizedAccordions,
  FeaturedLand,
  ReelNumber,
  TableComponent,
  TableView,
  Text,
} from "../../components";
import { Column } from "../../components/FlexComponents";
import { AppRoutes } from "../../config";
import ApiRoutes from "../../config/api.routes";
import useAuthorization from "../../contexts/useAuthorization";
import { useAxios } from "../../services/http.service";
import { LandToken } from "../../types/LandToken";
import { consoleError, sizing, toReadable } from "../../utils/methods";
import { ExploreLandsSchema, MobileEcoBankLandsSchema } from "../../utils/table-schemas";
import { BankWidget, BlockTitle, Row, WidgetGrid } from "../EcoBank";
import { StyledList } from "../EcoBank/components";
import PopUpGraph from "../../components/LineChart";
import { initializeBlogContent } from "../SupportCenter/BlogArticle";
import { EcoTokenStatus } from "../../utils/constants";

export const convertParcelsToHectares = (parcels: number) => {
  return (parcels * 100) / 10000;
};

// The widget values are underlined buttons. text-decoration can't reach into the reel's
// clipped digit cells, so the reel draws the 2px line itself (paint-only, no layout).
// .BankWidget-value has line-height 1.5 here, so the reel cell matches it.
const reelValueStyle = { boxShadow: "0 2px 0 currentColor", "--reel-cell": "1.5em" } as CSSProperties;

const Home = () => {
  const axios = useAxios();
  const { user } = useAuthorization();
  const [tokenList, setTokens] = useState<LandToken[]>([]);
  const [featuredNft, setFeaturedNft] = useState<LandToken | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showMoreLands, setShowMoreLands] = useState<Date | boolean>(false);

  const [indicatorsLoading, setIndicatorsLoading] = useState(true);
  // const [scannedLands, setScannedLands] = useState(0);
  // const [totalTransactions, setTotalTransactions] = useState(0);
  const [chartType, setChartType] = useState("price");
  const [open, setOpen] = useState(false);
  const [marketCap, setMarketCap] = useState(0);
  const [totalTrees, setTotalTrees] = useState(0);
  // const [sizeToHalving, setSizeToHalving] = useState(0);
  const [totalParcels, setTotalParcels] = useState(0);
  const [total, setTotal] = useState<number>(3);
  const [perPage, setPerPage] = useState<number>(0);
  const [blogArticles, setBlogArticles] = useState<{ [key: string]: any }>({});
  const [blogLoading, setBlogLoading] = useState(true);
  const handleOpen = (type: string) => {
    setChartType(type); // Update the chart type
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const handleMobileOpen = () => setOpen(true);

  const fetchIndicators = async () => {
    try {
      setIndicatorsLoading(true);
      const result = await axios.get(ApiRoutes.ecoBank.indicators.root).then((res) => res.data);
      // setScannedLands(result.soldLands || 0);
      // setTotalTransactions(result.totalTransactions || 0);
      const trees = result.tokens.reduce((acc: any, cur: any) => acc + toReadable(cur, cur !== "0", false), 0);
      const prices = result.prices.reduce((acc: any, cur: any) => acc + toReadable(cur, true, false), 0);
      const parcels = result.parcels.reduce((acc: any, cur: any) => acc + cur, 0);
      setMarketCap(prices);
      setTotalTrees(trees);
      setTotalParcels(convertParcelsToHectares(parcels));
      // const homeLandsData = await axios.get(ApiRoutes.token.list).then((res) => res.data);
      // const homeLands = homeLandsData.filter((item: LandToken) => item.etNft?.etAuction?.status === "started" || item.etNft?.status === "sold");
      // setHomeLands(homeLands);
      // setSizeToHalving(convertParcelsToHectares(1000000 - parcels));
    } catch (e) {
      consoleError("Failed to fetch indicators", { e });
    } finally {
      setIndicatorsLoading(false);
    }
  };

  // const fetchIndicators = async () => {
  //   try {
  //     setIndicatorsLoading(true);
  //     const result = await axios.get(ApiRoutes.ecoBank.indicators.root).then((res) => res.data);
  //     setScannedLands(result.soldLands || 0);
  //     setTotalTransactions(result.totalTransactions || 0);
  //   } catch (e: any) {
  //     console.log(e);
  //   } finally {
  //     setIndicatorsLoading(false);
  //   }
  // };

  const loadBlogContent = async () => {
    try {
      setBlogLoading(true);
      const content = await initializeBlogContent();
      setBlogArticles(content);
    } catch (error) {
      console.error("Failed to load blog content:", error);
    } finally {
      setBlogLoading(false);
    }
  };

  useEffect(() => {
    fetchTokens().then();
    fetchIndicators();
    loadBlogContent();
    if (user?.emailVerified) {
      //
    }
  }, []);

  const fetchTokens = async () => {
    const total = await axios.get(ApiRoutes.token.list + "?total=true").catch((err) => err.response);
    if (total && total.status === 200) {
      setTotal(total.data);
      if (total.data > 10) {
        setPerPage(10);
      } else {
        setPerPage(total.data);
      }
    }

    const result = await axios
      .get(ApiRoutes.token.list + "?status=" + EcoTokenStatus.VERIFIED + "&limit=4")
      .catch((err) => err.response);
    console.log({ result });
    if (result && result.status === 200 && result.data.length > 0) {
      const _auctions = result.data.filter(
        (item: LandToken) =>
          item.offerStatus === "opened" || item.etNft?.etAuction?.status === "started" || item.etNft?.status === "sold"
      );
      console.log({ _auctions });
      const featured = _auctions[0] || result.data[0];
      setFeaturedNft(featured);

      if (_auctions.length > 3) {
        setTokens([_auctions[0], _auctions[1], _auctions[2], _auctions[3]]);
      }
    } else {
      console.log({ result, tokenList });
    }
  };

  const landSchema = isMobile ? MobileEcoBankLandsSchema : ExploreLandsSchema;

  return (
    <>
      <Grid container width="100%" sx={{ backgroundColor: "#cccccc" }}>
        <Grid
          width="100%"
          flexDirection="column"
          sx={{ backgroundColor: "#cccccc", borderRadius: "0px 0px 20px 20px" }}
        >
          <Trending
            sx={{
              position: "relative",
              borderRadius: "20px 20px 20px 20px",
              border: "none",
            }}
          >
            {!blogLoading && blogArticles["1"] && (
              <>
                <img
                  src={blogArticles["1"].image}
                  alt="Blog article"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                    filter: "brightness(1)",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background:
                      "linear-gradient(to right, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.1) 100%)",
                    zIndex: 1,
                  }}
                />
                <BlogStoryBlock
                  blog={blogArticles["1"]}
                  sx={{
                    zIndex: 2,
                  }}
                  search={blogArticles["1"].Slug}
                  subtitle={blogArticles["1"].subtitle}
                  paragraph={blogArticles["1"].paragraph}
                  explore={AppRoutes.Explore.path}
                />
              </>
            )}
          </Trending>
        </Grid>

        <Grid width="100%" flexDirection="column" display="flex">
          <Attention
            sx={{
              backgroundColor: "back.homeBanner",
              p: sizing(6),
              borderColor: "back.homeBanner",
              borderRadius: " 20px 20px 20px 20px",
              textAlign: "center",
            }}
          >
            <Text large sx={{ color: "white", display: "inline" }}>
              Turn conservation into currency. Read the EcoFutures
              <Link
                style={{ color: "white", textDecoration: "underline", marginLeft: "6px" }}
                to={AppRoutes.EcoBank.path}
              >
                white paper
              </Link>
              .
            </Text>
          </Attention>
        </Grid>
        {featuredNft && featuredNft.etNft && <FeaturedLand land={featuredNft as any} />}

        <Row
          sx={{
            flexDirection: "column",
            width: "100%",
            backgroundColor: "back.table",
            overflowX: "scroll",
            borderRadius: "20px 20px 20px 20px",
          }}
        >
          <TableComponent
            mobileTitle=""
            schema={landSchema}
            apiURL={`${ApiRoutes.token.list}?etNftStatus=auction,sold`}
            // customData={homeLands}
            title=""
            removeAll={true}
            totalItems={total}
            batch={perPage}
            isLoading={indicatorsLoading}
            filter={{
              name: "filter",
              values: [
                ["latest lands", ["createdAt"]],
                ["price", ["price"]],
                ["mint cap", ["mintCap"]],
                ["score", ["ecoScore"]],
              ],
            }}
          />
        </Row>

        <Grid width="100%" flexDirection="column" display="flex">
          <Trending
            sx={{
              position: "relative",
              borderRadius: "20px 20px 20px 20px",
              border: "none",
            }}
          >
            {!blogLoading && blogArticles["3"] && (
              <>
                <img
                  src={blogArticles["3"].image}
                  alt="Blog article"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                    filter: "brightness(1)",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background:
                      "linear-gradient(to right, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.1) 100%)",
                    zIndex: 1,
                  }}
                />
                <BlogStoryBlock
                  blog={blogArticles["3"]}
                  sx={{
                    zIndex: 2,
                  }}
                  search={blogArticles["3"].Slug}
                  subtitle={blogArticles["3"].subtitle}
                  paragraph={blogArticles["3"].paragraph}
                />
              </>
            )}
          </Trending>
        </Grid>

        <Grid container justifyContent="center">
          <WidgetGrid container item xs={12} sx={{ borderRadius: "0px 0px 20px 20px" }}>
            <BankWidget
              sx={{
                width: "100%",
                height: { xs: "64px", md: "72px" },
                padding: { xs: "0 18px", md: "0 25px" },
                display: "flex !important",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#959A80",
                borderTop: "none",
                borderRadius: { xs: "20px 20px 0px 0px", md: "20px 0px 0px 20px" },
                position: "relative",
                "&::after, &::before": {
                  content: '""',
                  position: "absolute",
                  backgroundColor: "black",
                },
                "&::after": {
                  right: 0,
                  top: "25%",
                  height: "75%",
                  width: "1px",
                  display: { xs: "none", md: "block" },
                },
                "&::before": {
                  bottom: 0,
                  left: "5%",
                  width: "90%",
                  height: "1px",
                  display: { xs: "none", md: "block" },
                },
              }}
            >
              <Row sx={{ flexWrap: { xs: "wrap", md: "nowrap" }, width: "100%" }}>
                <Column sx={{ justifyContent: "center" }}>
                  <Public fontSize="large" />
                </Column>
                <Column sx={{ marginLeft: "12px", flex: 1 }}>
                  <BlockTitle>Market Capitalization (USD)</BlockTitle>
                  <button
                    className="BankWidget-value"
                    style={{
                      cursor: "pointer",
                      background: "transparent",
                      border: "none",
                      padding: 0,
                      fontFamily: "inherit",
                      fontSize: "inherit",
                      display: "flex",
                      color: "inherit",
                    }}
                    onClick={() => handleOpen("marketCap")}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        handleOpen("marketCap");
                      }
                    }}
                    aria-label="View Market Capitalization Chart"
                  >
                    {indicatorsLoading ? (
                      "..."
                    ) : (
                      <ReelNumber style={reelValueStyle} value={toReadable(marketCap, false, true, 0)} />
                    )}
                  </button>
                </Column>
              </Row>
            </BankWidget>
            <BankWidget
              sx={{
                width: "100%",
                height: { xs: "64px", md: "72px" },
                padding: { xs: "0 18px", md: "0 25px" },
                display: "flex !important",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#959A80",
                borderTop: "none",
                position: "relative",
                "&::after, &::before": {
                  content: '""',
                  position: "absolute",
                  backgroundColor: "black",
                },
                "&::after": {
                  right: 0,
                  top: "25%",
                  height: "75%",
                  width: "1px",
                  display: { xs: "none", md: "block" },
                },
                "&::before": {
                  bottom: 0,
                  left: "5%",
                  width: "90%",
                  height: "1px",
                  display: { xs: "none", md: "block" },
                },
              }}
            >
              <Row sx={{ flexWrap: { xs: "wrap", md: "nowrap" }, width: "100%" }}>
                <Column sx={{ justifyContent: "center" }}>
                  <EnergySavingsLeafOutlined fontSize="large" />
                </Column>
                <Column sx={{ marginLeft: "12px", flex: 1 }}>
                  <BlockTitle>Tree Mint Price (USD)</BlockTitle>
                  <button
                    className="BankWidget-value"
                    style={{
                      cursor: "pointer",
                      background: "transparent",
                      border: "none",
                      padding: 0,
                      display: "flex",
                      fontFamily: "inherit",
                      fontSize: "inherit",
                      color: "inherit",
                    }}
                    onClick={() => handleOpen("price")}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        handleOpen("price");
                      }
                    }}
                    aria-label="View Tree Mint Price Chart"
                  >
                    {indicatorsLoading ? (
                      "..."
                    ) : (
                      <ReelNumber
                        style={reelValueStyle}
                        value={toReadable(marketCap / totalTrees || 0, false, true, 4)}
                      />
                    )}
                  </button>
                </Column>
              </Row>
            </BankWidget>
            <BankWidget
              sx={{
                width: "100%",
                height: { xs: "64px", md: "72px" },
                padding: { xs: "0 18px", md: "0 25px" },
                display: "flex !important",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#959A80",
                borderTop: "none",
                borderRadius: { xs: "0px 0px 20px 20px", md: " 0px 20px 20px 0px" },
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  backgroundColor: "black",
                  bottom: 0,
                  left: "5%",
                  width: "90%",
                  height: "1px",
                  display: { xs: "none", md: "block" },
                },
              }}
            >
              <Row sx={{ flexWrap: { xs: "wrap", md: "nowrap" }, width: "100%" }}>
                <Column sx={{ justifyContent: "center" }}>
                  <DocumentScannerOutlined fontSize="large" />
                </Column>
                <Column sx={{ marginLeft: "12px", flex: 1 }}>
                  <BlockTitle>Total Hectares Scanned</BlockTitle>
                  <button
                    className="BankWidget-value"
                    style={{
                      cursor: "pointer",
                      background: "transparent",
                      border: "none",
                      padding: 0,
                      display: "flex",
                      fontFamily: "inherit",
                      fontSize: "inherit",
                      color: "inherit",
                    }}
                    onClick={() => handleOpen("supply")}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        handleOpen("supply");
                      }
                    }}
                    aria-label="View Total Hectares Scanned Chart"
                  >
                    {indicatorsLoading ? (
                      "..."
                    ) : (
                      <ReelNumber style={reelValueStyle} value={toReadable(totalParcels, false, true, 2)} />
                    )}
                  </button>
                </Column>
              </Row>
            </BankWidget>
          </WidgetGrid>
        </Grid>

        <Grid width="100%" flexDirection="column" display="flex">
          <Attention
            sx={{
              backgroundColor: "black",
              p: sizing(6),
              borderColor: "border.dark",
              borderRadius: " 20px 20px 20px 20px",
              textAlign: "center",
            }}
          >
            <Text large sx={{ color: "white", display: "inline", textAlign: "center" }}>
              <Link
                style={{ color: "white", textDecoration: "underline", marginRight: "6px" }}
                to={AppRoutes.EcoBank.path}
              >
                Enter the EcoFutures Terminal;
              </Link>
              view EFT prices, trade volumes, minting rates and scores.
            </Text>
          </Attention>
        </Grid>

        <Grid width="100%" flexDirection="column" display="flex">
          <Trending
            sx={{
              position: "relative",
              borderRadius: "20px 20px 20px 20px",
              border: "none",
            }}
          >
            {!blogLoading && blogArticles["4"] && (
              <>
                <img
                  src={blogArticles["4"].image}
                  alt="Blog article"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                    filter: "brightness(1)",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background:
                      "linear-gradient(to right, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.1) 100%)",
                    zIndex: 1,
                  }}
                />
                <BlogStoryBlock
                  blog={blogArticles["4"]}
                  sx={{
                    zIndex: 2,
                  }}
                  search={blogArticles["4"].Slug}
                  subtitle={blogArticles["4"].subtitle}
                  paragraph={blogArticles["4"].paragraph}
                />
              </>
            )}
          </Trending>
        </Grid>

        <Grid width="100%" flexDirection="column" display="none">
          <StyledList sx={{ height: "auto", paddingX: sizing(6) }}>
            <TableView
              data={tokenList.length > 3 && !showMoreLands ? tokenList.slice(0, 3) : tokenList}
              schema={ExploreLandsSchema}
            />
            {tokenList.length > 3 && (
              <ActionBtn
                variant="text"
                size="small"
                color="info"
                onClick={() => setShowMoreLands(!showMoreLands)}
                sx={{ marginY: sizing(6), padding: sizing(0) }}
              >
                {!showMoreLands ? "Show more" : "Show less"}
              </ActionBtn>
            )}
          </StyledList>
        </Grid>
        {/* 
        <Grid width="100%" flexDirection="column" display="none">
          <Attention sx={{ background: "var(--wheat)", p: sizing(6), color: "black" }}>
            <Text large sx={{ gap: 6 }}>
              Get the latest updates; <Link to={"#"}>subscribe now</Link>
            </Text>
          </Attention>
        </Grid> */}

        <Grid
          width="100%"
          flexDirection="column"
          display="flex"
          sx={{ paddingX: sizing(6), backgroundColor: "back.light", borderRadius: "20px 20px 20px 20px" }}
        >
          <CustomizedAccordions />
        </Grid>
      </Grid>
      {!isMobile && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ display: { md: "flex", sm: "none" }, alignItems: "center", justifyContent: "center" }}
        >
          <PopUpGraph onClose={handleClose} type={chartType} />
        </Modal>
      )}

      {isMobile && (
        <SwipeableDrawer
          anchor="bottom"
          open={open}
          onClose={handleClose}
          onOpen={handleMobileOpen}
          sx={{
            display: { xs: "block", sm: "none" },
            height: "100%",
            width: "100%",
            "& .MuiPaper-root": {
              backgroundColor: "transparent",
            },
          }}
        >
          <PopUpGraph onClose={handleClose} type={chartType} />
        </SwipeableDrawer>
      )}
    </>
  );
};

export const Trending = styled("div")`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(69vw - 0px);
  max-height: 600px;
  overflow: hidden;
  -webkit-transform: translateZ(0);

  & > img {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    margin: 0;
    padding: 0;
  }
`;

export const MapLink = styled(Link)`
  text-decoration: none;
  font-family: IBM Mono, monospace;
  color: ${({ theme }) => theme.palette.text.disabled};

  // &:hover {
  //   color: ${({ theme }) => theme.palette.text.primary};
  //   text-decoration: underline;
  // }
`;

export default Home;
